module.exports = __webpack_public_path__ + "static/media/2020-05-15 ono-otw.a3676fa3.md";